export enum FinancingTypes {
  lbo = 'LEVERAGED_BUY_OUT',
  growthEquity = 'GROWTH_EQUITY',
  juniorDebt = 'JUNIOR_DEBT',
  seniorDebt = 'SENIOR_DEBT',
  loc = 'LINE_OF_CREDIT',
  specialty = 'SPECIALTY',
}

export enum FinancingTypeLabels {
  lbo = 'LBO / Majority (Control)',
  growthEquity = 'Growth Equity / Minority (Non-control)',
  juniorDebt = 'Junior Debt (i.e., sub-debt or mezzanine loan)',
  seniorDebt = 'Senior Debt (i.e., term loans)',
  loc = 'Lines of credit',
  specialty = 'Specialty (equip, factoring, et al)',
}
